import { LoadingParagraph } from '@zg-rentals/loading-components';
import { Box, Card, Icon, Paragraph } from '@zillow/constellation-10';
import { IconChevronRightCircleFilled } from '@zillow/constellation-icons';

type Props = {
  onClick: () => void;
  label: string;
  count?: number;
  isLoading?: boolean;
};

const InquiryCountCard = ({ onClick, count, label, isLoading }: Props) => {
  return (
    <Card.Root
      tone="neutral"
      elevated={false}
      css={{
        marginLeft: { lg: '0' },
        marginRight: { lg: '0' },
        marginBottom: { base: '0', lg: '400' },
        cursor: 'pointer',
        padding: 'none',
      }}
    >
      <Card.Body
        onClick={onClick}
        css={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          height: '94px',
          padding: 'Card.Root.padding',
        }}
      >
        <Box css={{ display: 'flex', flexGrow: 1 }}>
          {typeof count === 'number' && (
            <LoadingParagraph
              data-testid="unread-value"
              textStyle="body-sm-bold"
              isLoading={Boolean(isLoading)}
              loadingWidth="50%"
            >
              {count}&nbsp;
            </LoadingParagraph>
          )}
          <Paragraph textStyle="body-sm" data-testid="unread-text">
            {label}
          </Paragraph>
        </Box>
        <Icon
          render={<IconChevronRightCircleFilled />}
          size="md"
          css={{ color: 'brand', float: 'right', position: 'relative' }}
        />
      </Card.Body>
    </Card.Root>
  );
};

export default InquiryCountCard;
